import React from 'react';
import { Check } from 'lucide-react';

const PublicTimeline = ({ steps, current }) => (
  <ol className="flex flex-col gap-0 sm:flex-row sm:items-stretch">
    {steps.map((step, idx) => {
      const done = idx < current;
      const active = idx === current;
      return (
        <li key={step.key} className="flex min-w-0 flex-1 sm:flex-col">
          <div className="flex items-center sm:w-full">
            <span
              className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xs font-bold ring-2 ${
                active
                  ? 'bg-primary-700 text-white ring-primary-200'
                  : done
                    ? 'bg-emerald-600 text-white ring-emerald-100'
                    : 'bg-white text-slate-400 ring-slate-200'
              }`}
            >
              {done ? <Check className="h-4 w-4" aria-hidden /> : idx + 1}
            </span>
            {idx < steps.length - 1 ? (
              <span
                className={`mx-2 hidden h-0.5 flex-1 sm:block ${done ? 'bg-emerald-400' : 'bg-slate-200'}`}
                aria-hidden
              />
            ) : null}
          </div>
          <div className="ml-3 pb-4 sm:ml-0 sm:mt-2 sm:pb-0">
            <p className="text-[11px] font-semibold uppercase tracking-wide text-slate-500">
              {active ? 'Situação atual' : done ? 'Concluída' : 'Próxima'}
            </p>
            <p className={`text-sm font-semibold ${active ? 'text-primary-900' : 'text-slate-800'}`}>
              {step.label}
            </p>
          </div>
        </li>
      );
    })}
  </ol>
);

export default PublicTimeline;
